import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

import { ApiNavigationStorefrontService } from 'idt-ecommerce-api/_api/api-navigation-storefront/api-navigation-storefront.service';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { ContextService } from 'idt-ecommerce-api/context/context.service';
import { buildStorefrontLocale } from 'idt-ecommerce-api/shared/helpers/storefront-language.helper';

import { Category } from './categories.models';
import { StorefrontMenuTransformer } from './storefront-menu.transformer';


@Injectable()
export class CategoriesService {

  constructor(
    private readonly apiNavigationStorefrontService: ApiNavigationStorefrontService,
    private readonly contextService: ContextService
  ) { }

  public categories(
    storeId?: string,
    catalogId?: string,
    currentLanguage: string | null = null
  ): Observable<Category[]> {
    return this.contextService.getContext$().pipe(
      first(),
      switchMap((context: EcommerceContext) => {
        const language = currentLanguage
          ? context.store.supportedLanguages.find((lang) => lang.id === currentLanguage) ?? context.currentLanguage
          : context.currentLanguage;
        const locale = buildStorefrontLocale(language, context.store.countryCode);
        const numericCatalogId = Number(catalogId ?? context.currentCatalogId) || undefined;

        return this.apiNavigationStorefrontService.getMenu(
          storeId ?? context.store.id,
          { language: locale, catalogId: numericCatalogId }
        ).pipe(
          map((menu) => StorefrontMenuTransformer.categoriesFromStorefrontMenu(menu, context))
        );
      })
    );
  }

}
